<template>
  <!-- <div> -->
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->

  <!-- <v-container fluid id="outer-container">
    <v-layout row wrap id="wrap-container"> -->
  <div style="background-color: #ffffff;">
    <section>
      <!-- <v-carousel :cycle="false" style="height: 590px;"> -->
      <v-carousel style="height: 590px;" :interval="speed" :cycle="false" class="test-class">
        <v-carousel-item
          v-for="(image,i) in images"
          :key="i"
          :src="image"
          class="item-class"
        >
          <template v-if="i === 0">
            <h1 class="header-title header-two" style="line-height: 0.95; margin-top: calc(128px + 1rem); margin-bottom: 1.3rem;" v-if="!mobile">Building quality<br> casino content</h1>
            <h1 class="header-title header-two" style="line-height: 0.95; margin-top: 5rem; margin-bottom: 1.3rem;" v-else>Building quality casino content</h1>

            <p class="header-body body-two" v-if="!mobile">
              King Show Games has created mega-hits<br>
              like "Lucky Larry's Lobstermania" and "$tinkin' Rich".
            </p>
            <v-layout justify-center v-else>
              <v-flex xs10>
                <p class="header-body body-two">
                  King Show Games has created mega-hits
                  like "Lucky Larry's Lobstermania" and "$tinkin' Rich".
                </p>
              </v-flex>
            </v-layout>

            <v-layout row justify-center class="play-buttons">
              <v-flex xs12>
                <v-btn large to="/games" color="#f38120" class="header-btn"><span class="header-btn-text">OUR GAMES</span></v-btn>
              </v-flex>
            </v-layout>
          </template>

          <template v-if="i === 1">
            <h1 class="header-title header-three" style="line-height: 0.95; margin-top: calc(128px + 1rem); margin-bottom: 1.3rem;" v-if="!mobile">Proven casino<br> experience</h1>
            <h1 class="header-title header-three" style="line-height: 0.95; margin-top: 5rem; margin-bottom: 1.3rem;" v-else>Proven casino experience</h1>

            <p class="header-body body-three" v-if="!mobile">
              Our talented team has designed over 200 games, and we<br>
              have licensed titles being played in countries all over the world.
            </p>
            <v-layout justify-center v-else>
              <v-flex xs10>
                <p class="header-body body-three">
                  Our talented team has designed over 200 games, and we
                  have licensed titles being played in countries all over the world.
                </p>
              </v-flex>
            </v-layout>

            <v-layout row justify-center class="play-buttons">
              <v-flex xs12>
                <v-btn large to="/about" color="#f38120" class="header-btn"><span class="header-btn-text">LEARN MORE</span></v-btn>
              </v-flex>
            </v-layout>
          </template>
        </v-carousel-item>
      </v-carousel>
    </section>

    <section class='description-section'>
        <v-layout
          column
          wrap
          class="py-5"
          align-center
          xs10 offset-xs1
        >
          <v-flex xs12 class="my-3" style="width: 75%;">
            <div class="text-xs-center">
              <h2 class="headline headline-title">King Show Games creates ground-breaking and exciting games.</h2>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xs id="descriptionContainer">
              <v-layout row wrap align-center justify-center>
                <v-flex xs12 md10 class="ieFlex">
                  <v-card class="elevation-0 transparent">
                    <!-- <v-card-text class="text-xs-center">
                      <v-icon x-large class="blue--text text--lighten-2">color_lens</v-icon>
                    </v-card-text> -->
                    <img
                      :src="landBased"
                      style="border-radius: 1rem; width: 70%;">
                    <v-card-title primary-title class="layout justify-center pb-1">
                      <div class="headline text-xs-center description-section body-title"><span class="body-title">Land-Based Games</span></div>
                    </v-card-title>
                    <v-card-text class='description-section description-body' id="slot-games-text">
                      Played by millions of slot players in casinos across the globe.
                    </v-card-text>
                    <!-- <v-btn large color="#f38120" class="body-btn"><span class="header-btn-text">LEARN MORE</span></v-btn> -->
                    <v-btn outline round to="/land-based-games" color="#335091" class="body-btn">LEARN MORE</v-btn>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  },
  data () {
    return {
      video: 'WWoQVBokMAA',
      swiperOption: {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      images: [
        // require('../assets/carousel/Carousel_Header_LMS.png'),
        // require('../assets/carousel/Carousel_Header1.png'),
        // require('../assets/carousel/Carousel_Header2.png'),
        require('../assets/carousel/Carousel_Header3.png'),
        require('../assets/carousel/Carousel_Header4.png')
        // { src: require('../assets/carousel/9_FishingBob.jpg') },
        // { src: require('../assets/carousel/2_BlackStallion.jpg') },
        // { src: require('../assets/carousel/6_SnowDay.jpg') },
        // { src: require('../assets/carousel/5_Lobstermania2.jpg') },
        // { src: require('../assets/carousel/7_JadeFortune.jpg') },
        // { src: require('../assets/carousel/4_HotRoll.jpg') },
        // { src: require('../assets/carousel/8_FirePearl.jpg') }
      ],
      iconImage: require('../assets/Icon_DingSlotsDing.png'),
      smvIcon: require('../assets/ShowMeVegasSlotsLogo.png'),
      lmsIcon: require('../assets/LobsterManiaSlotsLogo.png'),
      googlePlay: require('../assets/buttons/Button_GooglePlayEnabled.png'),
      iosStore: require('../assets/buttons/Button_AppStoreEnabled.png'),
      smvGoogle: require('../assets/buttons/Button_GooglePlayEnabled-smv.png'),
      smvGoogleHover: require('../assets/buttons/Button_GooglePlayOver-smv.png'),
      smvIos: require('../assets/buttons/Button_AppStoreEnabled-smv.png'),
      smvIosHover: require('../assets/buttons/Button_AppStoreOver-smv.png'),
      smvFacebook: require('../assets/buttons/Button_FindUsEnabled.png'),
      smvFacebookHover: require('../assets/buttons/Button_FindUsOver.png'),
      smvButton: require('../assets/buttons/Button_PlayForFreeEnabled.png'),
      smvHover: require('../assets/buttons/Button_PlayForFreeOver.png'),
      landBased: require('../assets/thumbnails/Thumbnail_LandBased.png'),
      socialCasino: require('../assets/thumbnails/Thumbnail_SocialCasinos.png'),
      // lobster: require('../assets/thumbnails/Thumbnail_Lobstermania.png'),
      // ding: require('../assets/thumbnails/Thumbnail_DingSlotsDing.png'),
      // smvThumbnail: require('../assets/thumbnails/Thumbnail_SMVS.png'),
      windowWidth: 0,
      windowHeight: 0,
      speed: 10000,
      footerHeight: 0,
      originalFooter: 0
    }
  },
  computed: {
    computedWidth () {
      // switch (this.$vuetify.breakpoint.name) {
      //   case 'xs': return '220px'
      //   case 'sm': return '400px'
      //   case 'md': return '500px'
      //   case 'lg': return '600px'
      //   case 'xl': return '800px'
      // }
      return this.screenWidth
    },
    mobile () {
      // return navigator.userAgent.toLowerCase().indexOf('mobile') > -1
      return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || navigator.userAgent.toLowerCase().indexOf('android') > -1
    },
    ipad () {
      return navigator.userAgent.toLowerCase().indexOf('ipad') > -1
    }
  },
  methods: {
    // test (i) {
    //   console.log(i)
    // },
    changeImage (icon) {
      let el = document.querySelector(`#${icon}`)
      let hoverImage = icon + 'Hover'
      el.src = this[hoverImage]
      el.srcset = this[hoverImage]
    },
    defaultImage (icon) {
      let el = document.querySelector(`#${icon}`)
      el.src = this[icon]
      el.srcset = this[icon]
    },
    smvClick () {
      window.open('https://showmevegasslots.onelink.me/uBTP?promoLink=UmMlkY2Q4dYjMkW7&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.showmevegasslotsv2%3A%2F%2F', '_blank')
    },
    changeButton (term) {
      let termArr = term.split('-')
      let platform = termArr[0]
      let el = document.querySelector(`#${platform}Btn`)
      let image = this[termArr[1]]
      el.src = image
      el.srcset = image
      // let el = document.querySelector('#smvBtn')
      // el.src = this.smvHover
      // el.srcset = this.smvHover

      // let el = document.querySelector('#smvBtn div.v-image__image--contain')
      // el.style.backgroundImage = 'url(' + this.smvHover + ')'
    },
    defaultButton (term) {
      let termArr = term.split('-')
      let platform = termArr[0]
      let el = document.querySelector(`#${platform}Btn`)
      let image = this[termArr[1]]
      el.src = image
      el.srcset = image
      // let el = document.querySelector('#smvBtn')
      // el.src = this.smvButton
      // el.srcset = this.smvButton
      // let el = document.querySelector(`#smvBtn div.v-image__image--contain`)
      // el.style.backgroundImage = 'url(' + this.smvButton + ')'
    },
    getWindowWidth (event) {
      // this.windowWidth = document.documentElement.clientWidth
      this.windowWidth = window.innerWidth
      // console.log(window.innerWidth)

      if (this.windowWidth > 1850) {
        document.querySelector('#iosBtn').style.marginLeft = '0'
        document.querySelector('#dsdiosBtn').style.marginLeft = '0'
        document.querySelector('.gameImg').style.marginTop = '1rem'
      } else if (this.windowWidth > 1350 && this.windowWidth <= 1850) {
        document.querySelector('#iosBtn').style.marginLeft = '-3rem'
        document.querySelector('#dsdiosBtn').style.marginLeft = '-3rem'
        document.querySelector('.gameImg').style.marginTop = '2rem'
      } else if (this.windowWidth > 1050 && this.windowWidth <= 1350) {
        document.querySelector('#iosBtn').style.marginLeft = '-5rem'
        document.querySelector('#dsdBtn').style.marginLeft = '-5rem'
        document.querySelector('.gameImg').style.marginTop = '2rem'
      } else if (this.windowWidth > 700 && this.windowWidth <= 1050) {
        document.querySelector('#iosBtn').style.marginLeft = '-7rem'
        document.querySelector('#dsdBtn').style.marginLeft = '-7rem'
        document.querySelector('.gameImg').style.marginTop = '2rem'
      } else if (this.windowWidth > 600 && this.windowWidth <= 700) {
        document.querySelector('#iosBtn').style.marginLeft = '-9rem'
        document.querySelector('#dsdiosBtn').style.marginLeft = '-7rem'
        document.querySelector('.header-title').style.fontSize = '62px'
        document.querySelector('.header-body').style.fontSize = '20px'

        document.querySelector('.header-two').style.fontSize = '62px'
        document.querySelector('.body-two').style.fontSize = '20px'

        document.querySelector('.header-three').style.fontSize = '62px'
        document.querySelector('.body-three').style.fontSize = '20px'
        document.querySelector('.gameImg').style.marginTop = '2rem'
      } else if (this.windowWidth > 470 && this.windowWidth <= 600) {
        document.querySelector('#iosBtn').style.marginLeft = '-9rem'
        document.querySelector('#dsdiosBtn').style.marginLeft = '-9rem'
        document.querySelector('.header-title').style.fontSize = '50px'
        document.querySelector('.header-body').style.fontSize = '16px'

        document.querySelector('.header-two').style.fontSize = '50px'
        document.querySelector('.body-two').style.fontSize = '16px'

        document.querySelector('.header-three').style.fontSize = '50px'
        document.querySelector('.body-three').style.fontSize = '16px'
        document.querySelector('.gameImg').style.marginTop = '3rem'
      } else if (this.windowWidth > 400 && this.windowWidth <= 450) {
        document.querySelector('#iosBtn').style.marginLeft = '-9rem'
        document.querySelector('#dsdiosBtn').style.marginLeft = '-9rem'
        document.querySelector('.header-title').style.fontSize = '45px'
        document.querySelector('.header-body').style.fontSize = '14px'

        document.querySelector('.header-two').style.fontSize = '45px'
        document.querySelector('.body-two').style.fontSize = '14px'

        document.querySelector('.header-three').style.fontSize = '45px'
        document.querySelector('.body-three').style.fontSize = '14px'
        // document.querySelector('.gameImg').style.marginTop = '3.5rem'
      } else if (this.windowWidth <= 400) {
        document.querySelector('#iosBtn').style.marginLeft = '-9rem'
        document.querySelector('#dsdiosBtn').style.marginLeft = '-9rem'
        document.querySelector('.header-title').style.fontSize = '40px'
        document.querySelector('.header-body').style.fontSize = '15px'

        document.querySelector('.header-two').style.fontSize = '40px'
        document.querySelector('.body-two').style.fontSize = '13px'

        document.querySelector('.header-three').style.fontSize = '40px'
        document.querySelector('.body-three').style.fontSize = '13px'
        // document.querySelector('.gameImg').style.marginTop = '3.5rem'
      }
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    },
    changeSocialHeight (event) {
      // if (this.windowWidth >= 960) {
      //   let slotHeight = document.querySelector('#slot-games-text').clientHeight
      //   document.querySelector('#social-casino-text').style.height = slotHeight.toString() + 'px'
      // } else if (this.windowWidth >= 738 && this.windowWidth < 960) {
      //   document.querySelector('#social-casino-text').style.height = '52px'
      // } else if (this.windowWidth > 408 && this.windowWidth <= 737) {
      //   document.querySelector('#social-casino-text').style.height = '88px'
      // } else if (this.windowWidth > 350 && this.windowWidth <= 408) {
      //   console.log(this.windowWidth)
      //   document.querySelector('#social-casino-text').style.height = '124px'
      // } else if (this.windowWidth >= 0 && this.windowWidth <= 350) {
      //   document.querySelector('#social-casino-text').style.height = '160px'
      // }
      if (this.windowWidth >= 1264) {
        document.querySelector('#slot-games-text').style.height = '88px'
      } else if (this.windowWidth >= 960 && this.windowWidth < 1264) {
        document.querySelector('#slot-games-text').style.height = '160px'
      } else if (this.windowWidth >= 714 && this.windowWidth < 960) {
        document.querySelector('#slot-games-text').style.height = '52px'
      } else if (this.windowWidth >= 422 && this.windowWidth < 714) {
        document.querySelector('#slot-games-text').style.height = '88px'
      } else if (this.windowWidth >= 0 && this.windowWidth < 422) {
        document.querySelector('#slot-games-text').style.height = '124px'
      }
    }
  },
  mounted () {
    // commented all these below as I changed to align-center from align-start for v-layout for cards
    this.$nextTick(function () {
      // window.addEventListener('resize', this.getWindowWidth)
      // window.addEventListener('resize', this.getWindowHeight)
      // window.addEventListener('resize', this.changeSocialHeight)

      // Init
      // this.getWindowWidth()
      // this.getWindowHeight()
      // this.changeSocialHeight()
    })

    document.querySelector('.v-window__container').style.height = '100%'
    document.querySelector('.v-carousel__item').style.height = '100%'
    document.querySelector('.v-carousel__controls').style.background = 'rgba(0,0,0,0)'
    // document.querySelectorAll('.v-carousel__controls__item').forEach(function (el) {
    //   console.log(el)
    //   el.style.marginLeft = '0px !important'
    //   el.style.marginRight = '0px !important'
    // })

    // if (this.mobile) {
    //   Array.from(document.querySelectorAll('.playNowLink')).forEach(function (el) {
    //     el.href = 'https://dingslotsding.onelink.me/EsB9?promoLink=hiwr7xiuolZN3wYK&utm_source=KSGWebSite&utm_medium=ksg_website_mobile&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.dingslotsding%3A%2F%2F'
    //   })
    // } else {
    //   Array.from(document.querySelectorAll('.storeLinks')).forEach(function (el) {
    //     el.href = 'https://dingslotsding.onelink.me/EsB9?promoLink=3s9BpWKFc2UIIQaN&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.dingslotsding%3A%2F%2F'
    //   })
    // }

    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
      Array.from(document.querySelectorAll('.ieFlex')).forEach(function (el) {
        let docFrag = document.createDocumentFragment()
        while (el.firstChild) {
          let child = el.removeChild(el.firstChild)
          docFrag.appendChild(child)
        }

        // replace el with document fragment
        el.parentNode.replaceChild(docFrag, el)
      })

      this.footerHeight = parseInt(getComputedStyle(document.querySelector('#descriptionContainer')).height) + 30

      this.originalFooter = parseInt(getComputedStyle(document.querySelector('#footer')).height)
      document.querySelector('#footer').style.height = this.footerHeight + 'px'
    }

    // resizing UI; commented out for now to push 2 new jobs
    // window.onresize = function () {
    //   console.log(`Width: ${window.innerWidth}`)
    //   console.log(`Height: ${window.innerHI}`)
    //   console.log('===')
    // }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
    window.removeEventListener('resize', this.changeSocialHeight)

    document.querySelector('#footer').style.height = this.originalFooter + 'px'
  }
}
</script>

<style lang="scss" scoped>
#outer-container {
  display: grid;
  justify-content: center;
}

#wrap-container {
  color: white;
  text-align: left;
  width: 70vw;
}

.gameImg {
  margin-top: 1.5rem;
}

.header-btn {
  border-radius: 2rem;
  position: relative;
}

.header-title {
  font-family: museo-slab, serif;
  font-style: italic;
  font-weight: 800;
  color: #ffffff;
  font-size: 3.8rem;
}

.lms-header-title {
  font-family: museo-slab, serif;
  font-style: italic;
  font-weight: 800;
  color: #1d3464;
  font-size: 3.8rem;
}

.mobile-header-title {
  font-family: museo-slab, serif;
  font-style: italic;
  font-weight: 800;
  color: #ffffff;
  line-height: 1;
  font-size: 2.8rem;
}

.lms-mobile-header-title {
  font-family: museo-slab, serif;
  font-style: italic;
  font-weight: 800;
  color: #1d3464;
  line-height: 1;
  font-size: 2.8rem;
}

.header-body {
  font-family: lato, sans-serif;
  font-style: normal;
  font-weight: 500;
  color: #ffffff;
  font-size: 20px;
  line-height: 1.3;
}

.lms-header-body {
  font-family: lato, sans-serif;
  font-style: normal;
  font-weight: 600;
  color: #001740;
  font-size: 20px;
  line-height: 1.3;
}

.mobile-header-body {
  font-family: lato, sans-serif;
  font-style: normal;
  font-weight: 500;
  color: #ffffff;
  font-size: 20px;
  line-height: 1.2;
}

.lms-mobile-header-body {
  font-family: lato, sans-serif;
  font-style: normal;
  font-weight: 600;
  color: #001740;
  font-size: 20px;
  line-height: 1.2;
}

.mobileHeader {
  margin-top: 5rem;
}

.header-btn-text {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  color: #ffffff;
  font-size: 27px;
}

.buttonMargin {
  margin-top: -1.75rem;
}

.swiper-slide {
  display: flex;
  justify-content: center;
}

.description-section {
  // color: white;
}

.description-body {
  padding-top: 0;
  font-family: lato, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #222222;
}

.header-btn-flex {
  display: grid;
  align-self: center;
}

.headline-title {
  font-family: museo-slab, serif !important;
  font-style: normal;
  font-weight: 700;
  font-size: 30px !important;
  color: #335091;
  letter-spacing: -1px !important;
}

.body-title {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 700;
  font-size: 33px;
  color: #f6821f;
}

.body-btn {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  padding-left: 5rem;
  padding-right: 5rem;
}

.item-class, .v-carousel__item {
  height: 100%;
}

@media only screen and (min-width: 2000px) {
  #smvButton {
    margin-top: -1rem;
  }
}

@media only screen and (min-width: 2150px) {
  #smvButton {
    margin-top: -2rem;
  }
}

@mixin lhCrop($line-height) {
  &::before {
    content: '';
    display: block;
    height: 0;
    width: 0;
    margin-top: calc((1 - #{$line-height}) * 0.5em);
  }
}

.text-to-crop {
  @include lhCrop(1.25); //line-height: 1.2
}

sup {
  vertical-align: sub;
}
</style>
